// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards-module--container--1lrdD","card":"Cards-module--card--3dXpg","illustration":"Cards-module--illustration--3JZiM"};